import type { VisitorProfilesQuery } from '@/gql/myomr'

export type CompanyVisitorProfile = VisitorProfilesQuery['visitorProfiles']['visitorProfiles']['nodes'][number]
export type VisitorProfile = CompanyVisitorProfile['profile']

export type Tab = 'all' | 'new' | 'interesting' | 'contacted' | 'not_relevant'

export const FILTER_TYPES = [
  'companyNames',
  'companyPositions',
  'companyJobLevels',
  'companySizes',
  'companyFields',
  'companyDepartments',
  'companyIndustries',
  'companyTypes',
  'countries',
  'userInterests',
  'networkingInterests',
] as const
export type FilterType = (typeof FILTER_TYPES)[number]

export type Facet = {
  id: string
  name: string
}

export type NetworkingFacet = Facet & {
  parentId?: number | null
  parentName?: string | null
}
